import Bowser from 'bowser';

const getBrowserOptions = () => Bowser.parse(window.navigator.userAgent);

export const isMobile = () => getBrowserOptions().platform.type !== 'desktop';
